/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_02_TitleInputs */

const en_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in AI security and career data governance.`)
};

const de_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein neuer Standard für KI-Sicherheit und Karrieredaten-Governance.`)
};

const fr_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in career data privacy.`)
};

const es_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in career data privacy.`)
};

const it_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in career data privacy.`)
};

const nl_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in career data privacy.`)
};

const pl_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in career data privacy.`)
};

const fi_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in career data privacy.`)
};

const da_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in career data privacy.`)
};

const sv_landing_section_02_title = /** @type {(inputs: Landing_Section_02_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new standard in career data privacy.`)
};

/**
* | output |
* | --- |
* | "A new standard in AI security and career data governance." |
*
* @param {Landing_Section_02_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_02_title = /** @type {((inputs?: Landing_Section_02_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_02_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_02_title(inputs)
	if (locale === "fr") return fr_landing_section_02_title(inputs)
	if (locale === "es") return es_landing_section_02_title(inputs)
	if (locale === "it") return it_landing_section_02_title(inputs)
	if (locale === "nl") return nl_landing_section_02_title(inputs)
	if (locale === "pl") return pl_landing_section_02_title(inputs)
	if (locale === "fi") return fi_landing_section_02_title(inputs)
	if (locale === "da") return da_landing_section_02_title(inputs)
	if (locale === "sv") return sv_landing_section_02_title(inputs)
	return en_landing_section_02_title(inputs)
});